import React, { useEffect, useState } from "react";
import { CheckCircle2, Timer } from "lucide-react";
import { api } from "@/lib/api";

const fmtDuration = (minutes) => {
  if (minutes == null) return "";
  if (minutes < 60) return `${minutes} Min.`;
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  if (days > 0) return `${days} Tag${days > 1 ? "e" : ""}${hours ? ` ${hours} Std.` : ""}`;
  return `${hours} Std.${minutes % 60 ? ` ${minutes % 60} Min.` : ""}`;
};

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function MyCompletedCardsWidget() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/boards/me/completed-cards")
      .then((r) => setCards(r.data || []))
      .catch(() => setCards([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || cards.length === 0) return null;

  return (
    <div className="bg-white border border-slate-200 p-6" data-testid="my-completed-cards-widget">
      <div className="flex items-center gap-2 mb-4">
        <CheckCircle2 size={14} strokeWidth={1.5} className="text-emerald-600" />
        <div className="text-xs font-bold uppercase tracking-overline text-slate-500">
          Erledigte Board-Aufgaben
        </div>
      </div>
      <div className="space-y-2">
        {cards.map((c) => (
          <div
            key={c.card_id}
            data-testid={`my-completed-card-${c.card_id}`}
            className="flex items-center justify-between gap-3 py-2 border-b border-slate-100 last:border-b-0"
          >
            <div className="min-w-0">
              <div className="text-sm text-slate-800 truncate">{c.title}</div>
              <div className="text-xs text-slate-400">{c.board_name} · erledigt am {fmtDate(c.completed_at)}</div>
            </div>
            {c.duration_minutes != null && (
              <div className="flex items-center gap-1.5 text-xs font-medium text-slate-600 shrink-0 whitespace-nowrap">
                <Timer size={12} strokeWidth={1.5} /> {fmtDuration(c.duration_minutes)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
